import { candidateStatusService } from '@/services/api/candidateStatus.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { candidateStatusModel } from '@/models/api/candidateStatus.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const CANDIDATE_STATUS_MODULE = "api/candidateStatus";

// ACTIONS
export const GET_ALL_CANDIDATE_STATUS = 'getAllCandidateStatus';
export const CREATE_CANDIDATE_STATUS = 'createCandidateStatus';
export const GET_CANDIDATE_STATUS = 'getCandidateStatus';
export const UPDATE_CANDIDATE_STATUS = 'updateCandidateStatus';
export const UPDATE_CANDIDATE_STATUS_SEQUENCE = 'updateCandidateStatusSequence';
export const UPDATE_CANDIDATE_STATUS_STATUS = 'updateCandidateStatusStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_CANDIDATE_STATUS_SUCCESS = "allCandidateStatusSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_CANDIDATE_STATUS_SUCCESS = "getCandidateStatusSuccess";

export const actions = {
    [GET_ALL_CANDIDATE_STATUS]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return candidateStatusService
            .getAll(filter)
            .then((result) => {
                commit(ALL_CANDIDATE_STATUS_SUCCESS, {data: result});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_CANDIDATE_STATUS]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return candidateStatusService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE_STATUS, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_CANDIDATE_STATUS]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return candidateStatusService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_CANDIDATE_STATUS_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_CANDIDATE_STATUS]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return candidateStatusService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE_STATUS, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_CANDIDATE_STATUS_SEQUENCE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return candidateStatusService
            .updateSequence(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE_STATUS, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_CANDIDATE_STATUS_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return candidateStatusService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE_STATUS, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_CANDIDATE_STATUS_SUCCESS](state, {data}) {
        let candidateStatusList = data.data || [];
        state.list.data = candidateStatusList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = candidateStatusList.map(item => candidateStatusModel(item));
        }
    },
    [GET_CANDIDATE_STATUS_SUCCESS](state, data) {
        state.details = candidateStatusModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};

